export default __webpack_public_path__ + "5c3f27e4a3228ab7e5beaa7045d23c9e.png";